module.exports = __webpack_public_path__ + "static/media/NoData.98d42638.png";